module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/discharge-9deb86482181a7a39c3a2f0af0cc8594.svg";